export enum PaymentFlow {
  INVOICE = 'invoice',
  RENEW = 'renew',
  DIRECT = 'direct',
  SALE_INVOICE = 'sale-invoice',
  FIRST_INVOICE_PAYMENT = 'first-invoice-payment',
  UPGRADE = 'upgrade',
}
